








































import Vue from 'vue';
import pipeline from '@/pipeline';
import PipelineMenu from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import BackButton from '@/components/BackButton.vue';
import AddressFinancialSponsorForm, {
  AddressFinancialSponsorFormEvent,
} from '@/components/forms/studentData/AddressFinancialSponsorForm.vue';
import Checkbox from '@/components/Checkbox.vue';
import LoadingPage from '@/components/LoadingPage.vue';
import Analytics from '@/helpers/analytics';
import { Toast } from '@descomplica/vue-components';
import { formatStringToDate } from '@/helpers/formatters';

export default Vue.extend({
  components: {
    PipelineMenu,
    BackButton,
    BottomButton,
    AddressFinancialSponsorForm,
    Checkbox,
    LoadingPage,
    Toast,
  },
  data() {
    return {
      sponsorAddressInfo: {
        sponsorZipCode: this.$store.getters.sponsorAddress?.sponsorZipCode || '',
        sponsorNeighborhood: this.$store.getters.sponsorAddress?.sponsorNeighborhood || '',
        sponsorStreet: this.$store.getters.sponsorAddress?.sponsorStreet || '',
        sponsorNumber: this.$store.getters.sponsorAddress?.sponsorNumber || '',
        sponsorComplement: this.$store.getters.sponsorAddress?.sponsorComplement || '',
        sponsorState: this.$store.getters.sponsorAddress?.sponsorState || '',
      },
      sameAddress: false,
      isLoading: false,
      error: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      const { sponsorComplement, ...objectValidation } = this.sponsorAddressInfo;
      return Object.values(objectValidation).every(Boolean) && !this.error;
    },
    partnerCode(): string {
      return this.$store.getters.partnerCode || '';
    },
  },
  methods: {
    inputHandler(sponsorAddressForm: AddressFinancialSponsorFormEvent) {
      this.sponsorAddressInfo = sponsorAddressForm;
    },
    async finishHandler() {
      try {
        const { sponsorAddressInfo } = this;
        this.isLoading = true;
        await this.$store.dispatch('UPDATE_SPONSOR_ADDRESS_INFO', { sponsorAddressInfo });

        const student = this.$store.getters.personalData;
        const { studentAddress, partnerCode } = this.$store.getters;

        Analytics.track('Enrollment Data Sent', {
          email: student?.email,
          cep: studentAddress?.zipCode,
          grad_endereco: studentAddress?.street,
          grad_endereco_numero: studentAddress?.number,
          grad_endereco_complemento: studentAddress?.complement,
          grad_endereco_cidade: studentAddress?.neighborhood,
          grad_endereco_estado: studentAddress?.state,
          data_de_nascimento: student?.birthDate
            ? formatStringToDate(student?.birthDate)?.toISOString()
            : undefined,
          grad_raca: student?.race,
          cpf: student?.cpf,
          grad_cupom: partnerCode,
          partnerCoupon: partnerCode,
        });

        if (this.partnerCode) {
          await this.applyVoucher();
          await this.generateContract();
        }

        pipeline.next();
      } catch (err) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);
        throw err;
      } finally {
        this.isLoading = false;
      }
    },
    sponsorSameAddress(event: any) {
      this.sameAddress = event.target.checked;
    },
    async applyVoucher() {
      await this.$store.dispatch('APPLY_VOUCHER', {
        voucher: this.partnerCode,
      });
    },
    async generateContract() {
      await this.$store.dispatch('GENERATE_CONTRACT');
    },
  },
});
